import React from "react";
import { SvgIcon } from "@mui/material";

export default function AppStoreIcon() {
  return (
    <SvgIcon width="26" height="30" viewBox="0 0 26 30" fill="none">
      <g clipPath="url(#clip0_6703_57111)">
        <path
          d="M21.5027 15.938C21.5455 20.4781 25.5454 21.9889 25.5896 22.0081C25.5557 22.1146 24.9505 24.1611 23.4824 26.2749C22.2132 28.1025 20.8959 29.9233 18.8208 29.961C16.782 29.998 16.1263 28.7699 13.7952 28.7699C11.4648 28.7699 10.7364 29.9233 8.80624 29.998C6.8033 30.0727 5.27804 28.0219 3.9984 26.201C1.38334 22.4764 -0.615056 15.6762 2.06829 11.0859C3.40129 8.8063 5.78362 7.36289 8.36924 7.32586C10.3361 7.28894 12.1926 8.62949 13.3949 8.62949C14.5965 8.62949 16.8525 7.01737 19.2242 7.25411C20.2169 7.29485 23.004 7.64915 24.7936 10.2299C24.6493 10.3179 21.4681 12.1425 21.5027 15.9381V15.938ZM17.6708 4.78998C18.7343 3.52185 19.4499 1.75659 19.2547 0C17.7219 0.0606871 15.8685 1.0063 14.769 2.27367C13.7837 3.39609 12.9208 5.19247 13.1536 6.91422C14.8621 7.04447 16.6075 6.05888 17.6709 4.78998"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_6703_57111">
          <rect
            width="24.7947"
            height="30"
            fill="white"
            transform="translate(0.794922)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
